import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["type", "data-qa"]
const _hoisted_2 = { class: "a-button__labelContainer" }
const _hoisted_3 = { class: "a-button__primaryLabel" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "a-button__secondaryLabel"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("button", {
    type: [{ 'submit' : _ctx.type === _ctx.ButtonType.Submit }],
    class: _normalizeClass([[
                {
                    '-active': _ctx.active, '-fullWidth': _ctx.fullWidth,
                    '-increasedHeight': !!_ctx.secondaryLabel,
                },
                '-' + _ctx.type ], "a-button"]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["stop"])),
    "data-qa": _ctx.qaSelector
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{'-centered': !_ctx.iconName && !_ctx.secondaryIconName}, "a-button__content"])
    }, [
      (_ctx.iconName)
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 0,
            "icon-id": _ctx.iconName,
            class: _normalizeClass([{'-large': !!_ctx.secondaryLabel}, "a-button__primaryIcon"])
          }, null, 8, ["icon-id", "class"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isTranslationLabel)
            ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, null, 512)), [
                [_directive_translate, _ctx.label]
              ])
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                innerHTML: _ctx.label
              }, null, 8, _hoisted_5))
        ]),
        (_ctx.secondaryLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", { innerHTML: _ctx.secondaryLabel }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.secondaryIconName)
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 1,
            class: _normalizeClass([{'-large': !!_ctx.secondaryLabel}, "a-button__secondaryIcon"]),
            "icon-id": _ctx.secondaryIconName
          }, null, 8, ["class", "icon-id"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 10, _hoisted_1))
}